import * as ActionTypes from './ActionTypes';
import OrderTextApi from './OrderTextApi';

function setTextAsDeliveredSuccess(result: any): any {
    return { type: ActionTypes.SET_TEXT_DELIVERED_SUCCESS, result: result };
}

function setTextAsNotDeliveredSuccess(result: any): any {
    return { type: ActionTypes.SET_TEXT_AS_NOT_DELIVERED_SUCCESS, result: result };
}

export function setTextAsDelivered(
    id: number
): (dispatch: (result: any) => void, getState: any) => void {
    return (dispatch: (result: any) => void, getState: any) =>
        OrderTextApi.setTextAsDelivered(id).then((result: any) => {
            dispatch(setTextAsDeliveredSuccess(result));
        });
}

export function setTextAsNotDelivered(
    id: number
): (dispatch: (result: any) => void, getState: any) => void {
    return (dispatch: (result: any) => void, getState: any) =>
        OrderTextApi.setTextAsNotDelivered(id).then((result: any) => {
            dispatch(setTextAsNotDeliveredSuccess(result));
        });
}

function getTextInfoSucceeded(result: any): any {
    return { type: ActionTypes.GET_TEXT_INFO_SUCCESS, result: result };
}

export function getTextInfo(id: number): any {
    return (dispatch: any, getState: any) =>
        OrderTextApi.getOrderText(id).then((result: any) => {
            dispatch(getTextInfoSucceeded(result));
        });
}

function getAvailableCopywritersSucceeded(result: any): any {
    return { type: ActionTypes.GET_AVAILABLE_COPYWRITERS_SUCCESS, result: result }
}

export function getAvailableCopywriters(orderId: number): any {
    return (dispatch: any) =>
        OrderTextApi.getAvailableCopywriters(orderId).then((result: any) => {
            dispatch(getAvailableCopywritersSucceeded(result));
        });
}

function setCopywriterOnOrderSuccess(result: any): any {
    return { type: ActionTypes.SET_COPYWRITER_ON_ORDER_SUCCESS, result: result }
}

export function setCopywriterOnOrder(orderId: number, copywriterId: number): any {
    return (dispatch: any) =>
        OrderTextApi.setCopywriterOnOrder(orderId, copywriterId).then((result: any) => {
            dispatch(setCopywriterOnOrderSuccess(result));
        });
}

